import { createContext, useContext, useState } from 'react';
import { UnauthorizedPage } from 'src/experiences/Error/UnauthorizedPage';
import { noop } from 'src/utils/noop';
import { FunctionComponentWithChildren } from 'src/utils/types';

type UnauthorizedAccessGuardContextData = {
    raiseUnauthorizedAccess: () => void;
};

const UnauthorizedAccessGuardContext = createContext<UnauthorizedAccessGuardContextData>({
    raiseUnauthorizedAccess: noop,
});

export const useUnauthorizedAccessGuardContext = () => useContext(UnauthorizedAccessGuardContext);

export const UnauthorizedAccessGuardProvider: FunctionComponentWithChildren = ({ children }) => {
    const [isUnauthorizedAccessRaised, setIsUnauthorizedAccessRaised] = useState(false);

    return (
        <UnauthorizedAccessGuardContext.Provider
            value={{
                raiseUnauthorizedAccess: () => setIsUnauthorizedAccessRaised(true),
            }}>
            {isUnauthorizedAccessRaised && <UnauthorizedPage />}
            {!isUnauthorizedAccessRaised && children}
        </UnauthorizedAccessGuardContext.Provider>
    );
};
